import script from "./PortfolioDetailsScopes.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDetailsScopes.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDetailsScopes.vue?vue&type=style&index=0&id=80092722&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80092722"]])

export default __exports__